export default {
  totalPages: state => {
    return Math.ceil(state.servicesCount / state.limit)
  },
  currentPage: state => {
    return Math.ceil(state.skip / state.limit + 1)
  }
}
